import {setStore, getStore, removeStore} from '@/utils/storage';
import cookie from "react-cookies";

export function isAuthorLogin() {
  if (cookie.load('authortoken') == "" || cookie.load('authortoken') == null || cookie.load('authortoken') == undefined) {
    return false;
  }
  return true;
}

